import { render, staticRenderFns } from "./DialogUtil.vue?vue&type=template&id=6aefa650&scoped=true"
import script from "./DialogUtil.vue?vue&type=script&lang=js"
export * from "./DialogUtil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aefa650",
  null
  
)

export default component.exports